import React from 'react';
import { ServerService as instanceService } from './../../../services/server.service';
import CommonMessage from './../../common/commonMessage';
import { Link, Redirect, Route } from 'react-router-dom';
import { AuditLog } from './../../../services/auditlog.service';
import $ from 'jquery';
import "./resize.css";
import { FlavorService } from './../../../services/flavor.service';
import { ResourceService } from './../../../services/resource.service';
import { ReactDOM } from 'react-dom';
import { axiosRequestWithAuth } from '../../../constants/server.constant';
import { axiosInstance, API_HOST } from './../../../constants/server.constant';
import i18n from '../../../i18n';


class Resize extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customPlan_options: "SCPU",
            customPlan_table_options: "",
            isdatapresent: false,
            instancePlans: [],
            instanceFilterPlans: [],
            flavour: this.props.instance.flavor,
            imageRegionUrl: this.props.imageRegionUrl,
            computeRegionUrl: this.props.computeRegionUrl,
            flavorcurrentplan: "",
            flavorcurrentstorage: "",
            flavourSelectedStorage: "",
            message: "",
            msgType: "",
            plantoggle: true,
            monthlytoggle: false,
            hourlytoggle: false,
            ramtoggle: false,
            cputoggle: false,
            storagetoggle: false,
            disableresize: true,
            getselectedplan: "",
            getdcputype: "",
            closeDedicated: false,
            isYearly: false,
            isPrepaidMonthly: false,
            promocode: "",
            discount: "",
            amountChargeToResize: 0,
            flavourSelectedRam: "",
            flavourSelectedCpu: "",
            flavourCurrentRam: "",
            flavourCurrentCpu: "",
            resizeOutage: false,
            isBareMetal: false,
            currentPlanData: {}
        };

        this.handleinputs = this
            .handleinputs
            .bind(this);
        this.submit = this
            .submit
            .bind(this);
        this.setFlavorDetailsByRegion = this.setFlavorDetailsByRegion.bind(this);
        this.getCpuType = this.getCpuType.bind(this);
        this.shutOff = this.shutOff.bind(this);
        this.headerSortClick = this.headerSortClick.bind(this);
        this.setSortable = this.setSortable.bind(this);
        this.getDcpuType = this.getDcpuType.bind(this);
        this.setRadioButtonValue = this.setRadioButtonValue.bind(this);
    }
    setRadioButtonValue = (event, param1, param2, param3, param4, param5, param6) => {

        this.setState({
            getselectedplan: param1,
            customPlan_table_options: param1,
            flavourSelectedStorage: param3,
            flavourSelectedRam: param4,
            flavourSelectedCpu: param5,
            flavourSelectedPrice: param6
        });

    };
    componentDidMount() {
        $("main").removeClass("ls_expand");
        $("html").animate({ scrollTop: 0 }, "slow");
        this.props.bgShadowHandler(true);
        /*instanceService.getRegionListByType('compute').then(data => {

            if (data && data.length> 0) {
                console.log(data)
                this.setFlavorDetailsByRegion(data[0].url)
            }
        })*/
        this.getServerResize();

    }
    componentWillUnmount() {
        this.props.msgHandler("");
    }
    clearToastMessage = () => {
        setTimeout(() => {
            this.props.msgHandler("");
        }, 10000);
    };
    getServerResize = () => {
        FlavorService.getServerExists(this.props.instance.id).then(resp => {

            if(resp === false) {
                this.props.bgShadowHandler(false);
                this.setState({
                    message: "Error while fetching server details"
                });
                this.getPromoCodeDetails();
            }
            if(resp.error) {
                this.setState({
                    isYearly: false,
                    isPrepaidMonthly: false
                }, () => { this.getPromoCodeDetails(); });
            }
            if(!resp.error) {
                this.setState({
                    isYearly: resp.paymentType === "Y" ? true : false,
                    isPrepaidMonthly: resp.paymentType === "M" ? true : false,
                }, () => { this.getPromoCodeDetails(); });
            }

        });
    };
    getPromoCodeDetails = () => {
        if(this.state.isYearly || this.state.isPrepaidMonthly) {
            ResourceService.getResourceDetailsByResource(this.props.instanceId).then(resp => {
                if(resp === false) {
                    this.props.bgShadowHandler(false);
                    this.setState({
                        message: "Error while resource details"
                    });
                    return;
                }
                let discountData = resp.body.discount;
                if(discountData != null) {
                    this.setDiscount();
                }
                else {
                    this.setState({
                        promocode: null,
                        discount: 0
                    });
                }
                this.props.bgShadowHandler(false);

                this.setFlavorDetailsByRegion(this.props.instance.region);
            }).catch(err => {
                this.props.bgShadowHandler(false);
                this.setState({
                    message: "Error while resource details"
                });
            });
        } else {
            this.setFlavorDetailsByRegion(this.props.instance.region);
        }


    };
    setDiscount() {
        if(this.state.isYearly) {
            FlavorService.getDiscounts().then(resp => {
                if(Array.isArray(resp)) {

                    for(let i = 0; i < resp.length; i++) {
                        if(resp[i].code_type == "cloud") {
                            let ob = resp[i];
                            this.setState({ promocode: ob.code, discount: ob.discount });

                        }

                    }

                }
            });
        }
        else {
            FlavorService.getMonthlyDiscounts("month").then(resp => {
                if(Array.isArray(resp)) {

                    for(let i = 0; i < resp.length; i++) {
                        if(resp[i].code_type == "cloud") {
                            let ob = resp[i];
                            this.setState({ promocode: ob.code, discount: ob.discount });

                        }

                    }

                }
            });
        }


    }

    getFlavorDetails(flavorId) {
        let flavorList = JSON.parse(localStorage.getItem('flavorListDb'));
        if(flavorList !== null && flavorList !== undefined) {
            let flavorObj = undefined;
            try {
                flavorObj = flavorList.find(item => item.flavour_id === flavorId);
            }
            catch(err) {
                return '';
            }

            if(flavorObj === undefined) {
                try {
                    let flavorList1 = JSON.parse(localStorage.getItem('flavorList'));
                    flavorObj = flavorList1.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }
            }
            if(flavorObj === undefined) {
                return '';
            }
            console.log(flavorObj);
            let nameArr = flavorObj.name.split(' ');
            let price = parseInt(flavorObj.monthly_price);
            let type = 'SCPU';
            let dcpuFlavorType = "";
            if(nameArr[0].includes('DCPU')) {
                type = 'DCPU';
                dcpuFlavorType = flavorObj.type;
            }
            if(nameArr[0].includes("BM")) {
                type = 'BM';
                dcpuFlavorType = "";
            }
            let details = nameArr[1].toString().split('/');
            let ram = details[0];
            let processor = flavorObj.vcpus;
            let storage = details[2];
            return type + "," + dcpuFlavorType + ',' + ram + ',' + storage + "," + processor + "," + price;
        }

        return '';
    }

    setFlavorDetailsByRegion(regionUrl) {
        instanceService.getFlavorDetailsByRegion(regionUrl).then(flavors => {

            if(flavors === false) {
                this.props.bgShadowHandler(false);
                this.setState({
                    message: "Error while fetching plans"
                });
                return;
            }

            let flavourDetails = this.getFlavorDetails(this.state.flavour.id);
            console.log(flavourDetails);
            let flavourSplit = flavourDetails.split(",");
            let currentPlanData = flavors.find(item => item.id === this.state.flavour.id);
            this.setState({
                flavorcurrentplan: this.state.flavour.id,
                customPlan_table_options: this.state.flavour.id,
                customPlan_options: flavourSplit[0],
                flavorcurrentstorage: flavourSplit[3],
                getdcputype: flavourSplit[1],
                flavourCurrentRam: flavourSplit[2],
                flavourCurrentCpu: flavourSplit[4],
                currentPlanData: currentPlanData,
                flavourCurrentPrice: flavourSplit[5]
            });


            let items = [...flavors];

            items.sort(function (a, b) {
                if(parseInt(a.ram.slice(0, -2)) < parseInt(b.ram.slice(0, -2))) { return -1; }
                else if(parseInt(a.ram.slice(0, -2)) > parseInt(b.ram.slice(0, -2))) { return 1; }
                return 0;
            });
            if(this.state.customPlan_options === "SCPU") {
                this.setState({
                    instancePlans: items,
                    instanceFilterPlans: items.filter(filt => filt.type === this.state.customPlan_options)
                });
            }
            else if(this.state.customPlan_options === "BM") {
                this.setState({
                    instancePlans: [],
                    instanceFilterPlans: [],
                    isBareMetal: true,
                    isdatapresent: true
                });
            }
            else {
                this.setState({
                    instancePlans: items,
                    instanceFilterPlans: items.filter(filt => filt.type === this.state.getdcputype)
                });
            }

            this.props.bgShadowHandler(false);
        });

    }

    getCpuType = (e, type) => {
        if(type === "SCPU") {
            this.setState({
                customPlan_options: "SCPU",
                resizeOutage: false
            });

            let plans = this.state.instancePlans.filter(item => item.type === type);
            this.setState({
                customPlan_table_options: null,
                instanceFilterPlans: plans
            });
        } else {
            this.getDcpuType(e, "COF");
            this.setState({
                customPlan_options: "DCPU",
                getselectedplan: "",
                resizeOutage: false
            });

        }



    };

    getDcpuType = (e, dcputype) => {
        let dcpumode = "";
        if(dcputype === "MOF") {
            this.setState({
                getdcputype: "MOF"
            });
            dcpumode = "MOF";
        }
        if(dcputype === "COF") {
            this.setState({
                getdcputype: "COF"
            });
            dcpumode = "COF";
        }
        if(dcputype === "DOF") {
            this.setState({
                getdcputype: "DOF"
            });
            dcpumode = "DOF";
        }
        let plans = this.state.instancePlans.filter(item => item.type === dcpumode);
        console.log(plans);
        this.setState({
            instanceFilterPlans: plans,
            resizeOutage: false
        });
    };

    handleinputs = (event) => {

        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            [name]: val
        });
    };

    submit = (event) => {

        this.resizeClose(event);
        event.preventDefault();
        this.props.bgShadowHandler(true);
        let requestBody = {
            resize: {
                flavorRef: this.state.customPlan_table_options
            }
        };
        let confirmBody = {
            confirmResize: null
        };

        let resizeDto = {
            serverId: this.props.instanceId,
            regionUrl: this.props.computeRegionUrl,
            regionCode: this.props.instance.region,
            reqBody: requestBody,
            flavourId: this.state.customPlan_table_options,
            discountCode: this.state.promocode,
            serverName: this.props.instance.name,
            planType: this.state.customPlan_options,
            paymentType: this.state.isPrepaidMonthly ? "M" : "Y"
        };

        if(this.state.isYearly || this.state.isPrepaidMonthly) {
            this.setState({ message: 'Payment processing....', msgType: 'success' });
            ResourceService.resizePayment_v2(resizeDto).then(resp => {
                if(resp === false) {
                    this.props.bgShadowHandler(false);
                    this.setState({ message: 'An error occurred while resizing.', msgType: 'error' });

                    return;
                }
                if(resp?.statusCodeValue === 403 && String(resp?.body?.message).toLowerCase().startsWith("policy")) {
                    this.props.bgShadowHandler(false);
                    this.setState({
                        message: i18n.t('inst_resz_suspended_failure'),
                        msgType: 'error',
                    });
                    return;
                }
                if(resp.body.error) {
                    if(resp.body.message.includes("Resize")) {
                        this.props.bgShadowHandler(false);
                        this.setState({ message: 'An error occurred while resizing the instance.', msgType: 'error' });
                        return;
                    }
                    if(resp.body.message.includes("outage")) {
                        this.props.bgShadowHandler(false);
                        this.setState({ resizeOutage: true });
                        this.setState({ message: '' });
                        setTimeout(() => {
                            this.setState({ resizeOutage: false });
                        }, 15000);
                        var spanele = document.getElementById("spanOutage");
                        spanele.scrollIntoView();
                        return;
                    }
                    else {
                        this.props.bgShadowHandler(false);
                        if(localStorage.getItem("roleId") == 2) {
                            this.setState({ message: 'An error occurred while processing the card details. You can try again by adding another card or after sometime.', msgType: 'error' });
                        }
                        else {
                            this.setState({ message: 'An error occurred while processing the card details. Contact your admin.', msgType: 'error' });
                        }
                        return;
                    }

                }

                this.setState({ message: 'Instance resize processing....', msgType: 'success' });
                var instanceId = this.props.instanceId;
                var computeUrl = this.props.computeRegionUrl;
                var planType = this.state.customPlan_options;
                var history = this.props.history;
                let selectedStorage = parseInt(this.state.flavourSelectedStorage.slice(0, -2));
                let currentStorage = parseInt(this.state.flavorcurrentstorage.slice(0, -2));
                let region = this.props.instance.region;

                function confirm() {

                    instanceService.serverActionResize_v2(instanceId, computeUrl, planType, confirmBody, "confirmResize", region).then(resp => {
                        if(resp === false) {
                            this.props.bgShadowHandler(false);
                            return;
                        }
                        if(resp.body.error) {
                            //history.push("/index");
                            history.push({
                                pathname: "/index",
                                state: {
                                    val: 'resize'
                                }
                            });

                        }

                        if(resp || resp === "") {
                            let server = JSON.parse(sessionStorage.server);
                            const requestBody = {
                                "userId": localStorage.getItem("userId"),
                                "name": server.instance.name + " has been resized from " + currentStorage + "GB to " + selectedStorage + "GB",
                                "operation": "Instance Resize",
                                "region": region

                            };
                            AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {

                                if(resp === false);
                            });
                            //history.push("/index");
                            history.push({
                                pathname: "/index",
                                state: {
                                    val: 'resize'
                                }
                            });
                        }

                    });
                }
                setTimeout(confirm, 5000);
                /*instanceService.serverAction(this.props.instanceId,this.props.computeRegionUrl,requestBody).then(resp => {
                    if(resp === false){
                        this.props.bgShadowHandler(false)
                        this.setState({message:'Failed to perform Resize on this instance!',msgType:'error'});
                        return
                    }
                    if(resp !== ""){
                        this.props.bgShadowHandler(false)
                        this.setState({message:'Failed to perform Resize on this instance!',msgType:'error'});
                        return
                    }
                    if(resp || resp === ""){
                       this.props.msgHandler("Instance resize is processing....")
                       var instanceId = this.props.instanceId;
                       var computeUrl = this.props.computeRegionUrl;
                       var history = this.props.history
                       let selectedStorage = parseInt(this.state.flavourSelectedStorage.slice(0,-2))
                       let currentStorage = parseInt(this.state.flavorcurrentstorage.slice(0,-2))
                       let region =  this.props.instance.region
                       
                        function confirm(){
                            instanceService.serverAction(instanceId,computeUrl,confirmBody).then(resp => {
                                if(resp === false){
                                    this.props.bgShadowHandler(false)
                                    return
                                }
                               
                                if(resp || resp === ""){
                                    let server = JSON.parse(sessionStorage.server);
                                    const requestBody = {
                                        "userId" : localStorage.getItem("userId"),
                                        "name" : server.instance.name + " has been resized from "+ currentStorage+"GB to "+ selectedStorage+ "GB",
                                        "operation" : "Instance Resize",
                                        "region" :region
        
                                    }
                                    AuditLog.storeAuditLogs(requestBody,"instance").then((resp)=>{
                                       
                                        if(resp === false);
                                    })
                                    history.push("/index")
                                }
                                
                            }) 
                        }
                        setTimeout(confirm,5000)
                       
                   }
        
                })*/

            }).catch(resp => {
                this.props.bgShadowHandler(false);
                this.setState({ message: 'Failed to perform Resize on this instance!', msgType: 'error' });
                return;
            });
        }
        else {
            instanceService.serverActionResize_v2(this.props.instanceId, this.props.computeRegionUrl, this.state.customPlan_options, requestBody, "resize", this.props.instance.region).then(resp => {
                if(resp === false) {
                    this.props.bgShadowHandler(false);
                    this.setState({ message: 'Failed to perform Resize on this instance!', msgType: 'error' });
                    return;
                }
                if(resp.body.error) {
                    if(resp.body.message.includes("Outage")) {
                        this.props.bgShadowHandler(false);
                        this.setState({ resizeOutage: true });
                        setTimeout(() => {
                            this.setState({ resizeOutage: false });
                        }, 15000);
                        var spanele = document.getElementById("spanOutage");
                        spanele.scrollIntoView();
                        return;
                    }
                    else {
                        this.props.bgShadowHandler(false);
                        this.setState({ message: 'An error occurred while resizing the instance.', msgType: 'error' });
                        return;
                    }

                }


                this.props.msgHandler("Instance resize is processing....");
                this.clearToastMessage();
                var instanceId = this.props.instanceId;
                var computeUrl = this.props.computeRegionUrl;
                var planType = this.state.customPlan_options;
                var history = this.props.history;
                let selectedStorage = parseInt(this.state.flavourSelectedStorage.slice(0, -2));
                let currentStorage = parseInt(this.state.flavorcurrentstorage.slice(0, -2));
                let region = this.props.instance.region;

                function confirm() {
                    instanceService.serverActionResize_v2(instanceId, computeUrl, planType, confirmBody, "confirmResize").then(resp => {
                        if(resp === false) {
                            this.props.bgShadowHandler(false);
                            return;
                        }
                        if(resp.body.error) {
                            //history.push("/index");
                            history.push({
                                pathname: "/index",
                                state: {
                                    val: 'resize'
                                }
                            });
                        }

                        if(resp || resp === "") {
                            let server = JSON.parse(sessionStorage.server);
                            const requestBody = {
                                "userId": localStorage.getItem("userId"),
                                "name": server.instance.name + " has been resized from " + currentStorage + "GB to " + selectedStorage + "GB",
                                "operation": "Instance Resize",
                                "region": region

                            };
                            AuditLog.storeAuditLogs(requestBody, "instance").then((resp) => {

                                if(resp === false);
                            });
                            //history.push("/index");
                            history.push({
                                pathname: "/index",
                                state: {
                                    val: 'resize'
                                }
                            });
                        }

                    });
                }
                setTimeout(confirm, 5000);


            }).catch(err => {
                this.props.bgShadowHandler(false);
                this.setState({ message: 'An error occurred while resizing the instance.', msgType: 'error' });
                return;
            });
        }




    };

    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (param) => {
        let items = [...this.state.instanceFilterPlans];

        if(param === "plan") {
            if(this.state.plantoggle) {
                items.sort(function (a, b) {
                    if(parseInt(a.ram.slice(0, -2)) < parseInt(b.ram.slice(0, -2))) { return -1; }
                    else if(parseInt(a.ram.slice(0, -2)) > parseInt(b.ram.slice(0, -2))) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(parseInt(a.ram.slice(0, -2)) < parseInt(b.ram.slice(0, -2))) { return 1; }
                    else if(parseInt(a.ram.slice(0, -2)) > parseInt(b.ram.slice(0, -2))) { return -1; }
                    return 0;
                });
            }
            this.setState({
                plantoggle: !this.state.plantoggle
            });

        }
        else if(param === "month") {
            if(this.state.monthlytoggle) {
                items.sort(function (a, b) {
                    if(parseFloat(a.monthlyRate) < parseFloat(b.monthlyRate)) { return -1; }
                    else if(parseFloat(a.monthlyRate) > parseFloat(b.monthlyRate)) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(parseFloat(a.monthlyRate) < parseFloat(b.monthlyRate)) { return 1; }
                    else if(parseFloat(a.monthlyRate) > parseFloat(b.monthlyRate)) { return -1; }
                    return 0;
                });
            }
            this.setState({
                monthlytoggle: !this.state.monthlytoggle
            });

        }
        else if(param === "hour") {
            if(this.state.hourlytoggle) {
                items.sort(function (a, b) {
                    if(parseFloat(a.hourlyRate) < parseFloat(b.hourlyRate)) { return -1; }
                    else if(parseFloat(a.hourlyRate) > parseFloat(b.hourlyRate)) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(parseFloat(a.hourlyRate) < parseFloat(b.hourlyRate)) { return 1; }
                    else if(parseFloat(a.hourlyRate) > parseFloat(b.hourlyRate)) { return -1; }
                    return 0;
                });
            }
            this.setState({
                hourlytoggle: !this.state.hourlytoggle
            });

        }
        else if(param === "cpu") {
            if(this.state.cputoggle) {
                items.sort(function (a, b) {
                    if(parseInt(a.processor.slice(0, -3)) < parseInt(b.processor.slice(0, -3))) { return -1; }
                    else if(parseInt(a.processor.slice(0, -3)) > parseInt(b.processor.slice(0, -3))) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(parseInt(a.processor.slice(0, -3)) < parseInt(b.processor.slice(0, -3))) { return 1; }
                    else if(parseInt(a.processor.slice(0, -3)) > parseInt(b.processor.slice(0, -3))) { return -1; }
                    return 0;
                });
            }
            this.setState({
                cputoggle: !this.state.cputoggle
            });

        }
        else if(param === "storage") {
            if(this.state.storagetoggle) {
                items.sort(function (a, b) {
                    if(parseInt(a.storage.slice(0, -2)) < parseInt(b.storage.slice(0, -2))) { return -1; }
                    else if(parseInt(a.storage.slice(0, -2)) > parseInt(b.storage.slice(0, -2))) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(parseInt(a.storage.slice(0, -2)) < parseInt(b.storage.slice(0, -2))) { return 1; }
                    else if(parseInt(a.storage.slice(0, -2)) > parseInt(b.storage.slice(0, -2))) { return -1; }
                    return 0;
                });
            }
            this.setState({
                storagetoggle: !this.state.storagetoggle
            });
        }
        this.setState({
            instanceFilterPlans: items
        });

    };

    shutOff = () => {
        this.props.bgShadowHandler(true);
        instanceService.stopServer(this.props.instanceId, this.state.computeRegionUrl).then(resp => {
            if(resp || resp === "") {
                this.props.bgShadowHandler(false);
                this.setState({ message: "Instance shutting off" });
                this.moveToIndex("/index");
            }
            else {

                this.setState({ message: 'Failed to perform Turnoff on this instance!', msgType: 'error' });
                this.props.bgShadowHandler(false);
            }

        });
    };
    moveToIndex = (url) => {
        this.props.history.push({
            pathname: "/index",
            state: {
                val: 'resize'
            }
        });
        // this.props.history.push('/index');
    };
    resizeClose = (event) => {
        event.preventDefault();
        $('#resizeInst').removeClass('active');
    };

    resizeBtnClick = (event) => {
        event.preventDefault();
        if(this.state.customPlan_table_options === null || this.state.customPlan_table_options.length <= 0) {
            this.props.msgHandler("Select atleast one plan", "error");
            this.clearToastMessage();
            return;
        }
        else {
            if(this.state.isYearly || this.state.isPrepaidMonthly) {

                let data = {
                    serverId: this.props.instanceId,
                    regionUrl: this.props.computeRegionUrl,
                    flavourId: this.state.customPlan_table_options,
                    discountCode: this.state.promocode,
                    serverName: this.props.instance.name,
                    paymentType: this.state.isPrepaidMonthly ? "M" : "Y"
                };
                this.props.bgShadowHandler(true);
                ResourceService.fecthAmountToResize(data).then(resp => {
                    if(resp === false) {
                        this.props.bgShadowHandler(false);
                        this.props.msgHandler("Error while doing resize", "error");
                        this.clearToastMessage();
                        return;
                    }

                    if(resp.error) {
                        this.props.bgShadowHandler(false);
                        this.props.msgHandler("User not found Exception", "error");
                        this.clearToastMessage();
                        return;
                    }
                    this.props.bgShadowHandler(false);
                    let amountToCharge = resp.amount;
                    if(amountToCharge !== undefined && amountToCharge === '.00') amountToCharge = 0.00;
                    this.setState({
                        amountChargeToResize: amountToCharge
                    });
                    $('#resizeInst').addClass('active');
                    document.getElementById('setresizeBtn').focus();
                }).catch(error => {
                    this.props.bgShadowHandler(false);
                    this.props.msgHandler("Error while doing resize", "error");
                    this.clearToastMessage();
                    return;
                });
            }
            else {
                $('#resizeInst').addClass('active');
                document.getElementById('setresizeBtn').focus();
            }

        }


    };


    render() {
        if(this.props.instance.isSrcInst || this.props.instance.metadata?.opType === 'migration') {
            this.moveToIndex();
        }

        return (
            <section className={ this.state.isdatapresent ? "settingModule_wrapper" : "settingModule_wrapper resize_setting_module" }>

                { this.state.isdatapresent ? <div>
                    <div className="outer_empty_wrap">
                        <div className="inner_empty_wrap">
                            <div className="svg_wrap empty_icon resize_empty"></div>
                            <p className="empty_title">No resize plans available for bare metal</p>
                        </div>
                    </div>
                </div> : <div>

                    <div className="settModule_head_wrap">
                        <div className="settModule_head_lhs">
                            <h2>Resize</h2>
                            <p className="head_info">Resize the instance to a higher plan of your choice</p>
                        </div>
                    </div>
                    <div className="resizeModule_wrap clearfix">
                        <div className="plan_options">
                            <h3>Choose CPU sharing mode</h3>
                            <div className="customPlans_radio_wrap">
                                {/* <div style = {{display:this.state.customPlan_options === "SCPU"?"":"none"}}>
                            <div > */}
                                <label className={ this.state.customPlan_options === "SCPU" ? "custom_radio active" : "custom_radio" }>Shared CPU
                                    <input
                                        type="radio"
                                        value="shared"
                                        checked=
                                        { this.state.customPlan_options === "SCPU" }
                                        name="customPlan_options"
                                        onChange={ (e) => this.getCpuType(e, "SCPU") }></input>
                                    <span className="checkmark"></span>
                                </label>
                                {/* </div> */ }
                                {/* <div style = {{display:this.state.customPlan_options === "DCPU"?"":"none"}}>
                            <div > */}
                                <label className={ this.state.customPlan_options === "DCPU" ? "custom_radio active" : "custom_radio" }>Dedicated CPU
                                    <input
                                        type="radio"
                                        value="dedicated"
                                        name="customPlan_options"
                                        checked={ this.state.customPlan_options === 'DCPU' }
                                        onChange={ (e) => this.getCpuType(e, "DCPU") }></input>
                                    <span className="checkmark"></span>
                                </label>
                                {/* </div> */ }
                            </div>
                        </div>
                        <div className="plan_dcpu" style={ { display: this.state.customPlan_options === "DCPU" ? "" : "none" } }>
                            {/*<div className="dcpu_message"style = {{display:this.state.closeDedicated?"none":""}}>
                            <div className="notification_wrap"> 
                        
                            <div className="msg_wrap success_notify ">
                            <div className="msg_wrap_inner alert">
                            <p className="msg_wrap_test">Dedicated CPU instances are ideal to handle heavy workloads with optimum performance.<a href="https://www.idrivecompute.com/support.htm" target = "_blank"> Contact support</a> for more information.</p>
                            </div>
                            <div className="msg_wrap_close" onClick = {()=>{this.setState({closeDedicated : true})}} > <a className="close_info"><svg fill="#7293af" height="13px" width="13px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.31 13.31">
                            <title>close</title>
                            <polygon className="cls-1" points="13.31 1.82 11.49 0 6.66 4.84 1.82 0 0 1.82 4.84 6.66 0 11.49 1.82 13.31 6.66 8.47 11.49 13.31 13.31 11.49 8.47 6.66 13.31 1.82"></polygon>
                            </svg></a></div>
                            </div>
                            </div>
                        </div>*/}


                            <div className="dcpu_tabs">
                                <div className="tw_tabs">
                                    <ul className="d_flex">
                                        <li className={ this.state.getdcputype === "COF" ? "active" : "" } data-tabs="CPU-Optimized" onClick={ (e) => this.getDcpuType(e, "COF") }>
                                            <p className="text">CPU-Optimized</p>
                                        </li>
                                        <li className={ this.state.getdcputype === "MOF" ? "active" : "" } data-tabs="Memory-Optimized" onClick={ (e) => this.getDcpuType(e, "MOF") }>
                                            <p className="text">Memory-Optimized</p>
                                        </li>
                                        <li style={ { display: "none" } } className={ this.state.getdcputype === "DOF" ? "active" : "" } data-tabs="Storage-Optimized" onClick={ (e) => this.getDcpuType(e, "DOF") }>
                                            <p className="text">Storage-Optimized</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className="resize_table">
                            <div className="table_head_options">
                                <div className="txt_head" style={ { display: this.state.customPlan_options === "SCPU" ? "" : "none" } }>Customize memory, CPU, and storage of the compute instance</div>
                                <div className="cta_btn_wrap" style={ { display: "none" } }>
                                    <div className="help_choose_cta">
                                        <a href="">Help me choose
                                            <span className="svg_wrap">
                                                <svg
                                                    x="0px"
                                                    y="0px"
                                                    viewBox="0 0 512 512"
                                                    enableBackground="new 0 0 512 512"
                                                    xmlSpace="preserve">
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        fill="#0071BC"
                                                        d="M428.1,227.3c-15.8,0-28.6-12.8-28.6-28.6v-45.4L248,304.7  l-40.5-40.5L359,112.8h-45.4c-15.8,0-28.6-12.8-28.6-28.6s12.8-28.6,28.6-28.6h114.5c15.8,0,28.6,12.8,28.6,28.6v114.5  C456.7,214.5,443.9,227.3,428.1,227.3z M113.3,170v200.3c0,15.8,12.8,28.6,28.6,28.6h200.3c15.8,0,28.6-12.8,28.6-28.6v-85.8h57.2  v114.5c0,31.6-25.6,57.2-57.2,57.2H113.3c-31.6,0-57.2-25.6-57.2-57.2V141.4c0-31.6,25.6-57.2,57.2-57.2h114.5v57.2H142  C126.2,141.4,113.3,154.2,113.3,170z" />
                                                </svg>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className={ this.state.customPlan_options !== "SCPU" ? "" : "" }>
                                <div className={ this.state.customPlan_options !== "SCPU" ? "" : "" }></div>
                                <p className="noplan_info" style={ { display: this.state.instanceFilterPlans.length === 0 ? 'block' : 'none' } }>{ this.state.isBareMetal ? "Bare Metal instance can not be resized" : "No plans available at this time" }</p>

                                <div className={ this.state.customPlan_options === "SCPU" ? "plan_scpu" : "dedicated_block" } style={ { display: this.state.instanceFilterPlans.length > 0 ? 'block' : 'none' } }>
                                    <div className={ this.state.customPlan_options === "SCPU" ? "plan_container" : "" }>
                                        <ul className="scpu_tabs">
                                            <li className={ this.state.isYearly ? "active" : "" } data-tabs="SCPU-yearly" onClick={ () => this.setState({ isYearly: true }) } style={ { display: this.state.isYearly ? "block" : "none" } }>
                                                <p className="text">Prepaid Yearly</p>
                                            </li>
                                            <li className={ this.state.isPrepaidMonthly ? "active" : "" } data-tabs="SCPU-monthly" onClick={ () => this.setState({ isYearly: false }) } style={ { display: this.state.isPrepaidMonthly ? "block" : "none" } }>
                                                <p className="text">Prepaid Monthly</p>
                                            </li>
                                            <li className={ this.state.isYearly || this.state.isPrepaidMonthly ? "" : "active" } data-tabs="SCPU-monthly" onClick={ () => this.setState({ isYearly: false }) } style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? "none" : "block" } }>
                                                <p className="text">Postpaid Monthly</p>
                                            </li>
                                        </ul>

                                        <div className={ this.state.isYearly || this.state.isPrepaidMonthly ? "scpu_yearly_plan show" : "scpu_monthly_plan show" }>
                                            {/* {this.state.customPlan_options === "SCPU" && this.state.isYearly?<div className="scpu_offerBlk"></div>:""} */ }
                                            <div className="scpu_offerBlk no-bg">
                                                { this.state.isYearly ?
                                                    <div className="offer-text-blk">
                                                        <p className="saveoffer-txt" style={ { display: this.state.discount != 0 ? "" : "none" } }>Save <span className="red-hht-txt">{ this.state.discount }%<sup>*</sup></span> on first year</p>
                                                        <p className="subscribe-txt" style={ { display: this.state.discount != 0 ? "" : "none" } }>Subscribe to prepaid yearly plans and get discounts</p>
                                                        <p className="subscribe-txt" style={ { display: this.state.discount != 0 ? "none" : "" } }>Subscribe to prepaid yearly plans</p>
                                                    </div> :
                                                    this.state.isPrepaidMonthly ?
                                                        <div className="offer-text-blk">
                                                            <p className="saveoffer-txt" style={ { display: this.state.discount != 0 ? "" : "none" } }>Save <span className="red-hht-txt">{ this.state.discount }%<sup>*</sup></span> on first year</p>
                                                            <p className="subscribe-txt" style={ { display: this.state.discount != 0 ? "" : "none" } }>Subscribe to prepaid monthly plans and get discounts</p>
                                                            <p className="subscribe-txt" style={ { display: this.state.discount != 0 ? "none" : "" } }>Subscribe to prepaid monthly plans</p>
                                                        </div>
                                                        :
                                                        <div className="offer-text-blk">
                                                            <p className="monthly-paytxt">Pay as you use with monthly postpaid plans</p>
                                                        </div>
                                                }
                                            </div>
                                            <div className="tabular_data_wrap">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1">
                                                                <div className="header_sort_wrap" >Name
                                                                </div>
                                                            </div>
                                                            { this.state.isYearly ?
                                                                <div className="col col2">
                                                                    <div className="header_sort_wrap" style={ { display: this.state.customPlan_options === "SCPU" ? "" : "" } } onClick={ (event) => { this.headerSortClick(event); this.setSortable("month"); } }>Yearly<span className="sort_icon"></span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="col col2">
                                                                    <div className="header_sort_wrap" style={ { display: this.state.customPlan_options === "SCPU" ? "" : "" } } onClick={ (event) => { this.headerSortClick(event); this.setSortable("month"); } }>Monthly<span className="sort_icon"></span>
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className="col col3">
                                                                <div className="header_sort_wrap" style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? "none" : "" } } onClick={ (event) => { this.headerSortClick(event); this.setSortable("hour"); } }>Hourly<span className="sort_icon"></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col4">
                                                                <div className="header_sort_wrap">RAM
                                                                </div>
                                                            </div>
                                                            <div className="col col5">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("cpu"); } }>CPUs<span className="sort_icon"></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col6">
                                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("storage"); } }>NVMe Storage<span className="sort_icon active"></span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data" >
                                                    { this.state.customPlan_options === "SCPU" ?
                                                        <ul>

                                                            { this.state.instanceFilterPlans.map((instancedata, i) =>

                                                                <li key={ i }
                                                                    className={
                                                                        (this.state.currentPlanData.planName === instancedata.planName || parseInt(this.state.flavourCurrentPrice) >= parseInt(instancedata.monthlyRate) || this.state.flavorcurrentplan === instancedata.id || parseInt(this.state.flavorcurrentstorage.slice(0, -2)) > parseInt(instancedata.storage.slice(0, -2)))

                                                                            ? "tr current_plan"
                                                                            : "tr" }


                                                                    onClick={ (event) => this.setRadioButtonValue(event, instancedata.id, "", instancedata.storage, instancedata.ram, instancedata.processor, instancedata.monthlyRate) }>
                                                                    <div className="col col1">
                                                                        { this.state.customPlan_options === "SCPU" ?
                                                                            <div className="customPlans_radio_wrap">

                                                                                <label className={ instancedata.id === this.state.getselectedplan ? "custom_radio active" : "custom_radio" }>{ instancedata.planName } { this.state.flavorcurrentplan === instancedata.id
                                                                                    ? <span className="curr_plan_tag">Current Plan</span>
                                                                                    : "" }
                                                                                    { parseInt(this.state.flavorcurrentstorage.slice(0, -2)) > parseInt(instancedata.storage.slice(0, -2))
                                                                                        ?
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            //onChange={this.handleinputs}
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                            disabled>
                                                                                        </input> :
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                        // onChange={this.handleinputs}

                                                                                        >
                                                                                        </input>
                                                                                    }

                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </div>
                                                                            :
                                                                            <div className="customPlans_radio_wrap">

                                                                                <label className={ instancedata.id === this.state.getselectedplan ? "custom_radio active" : "custom_radio" }>{ instancedata.planName } { this.state.flavorcurrentplan === instancedata.id
                                                                                    ? <span className="curr_plan_tag">Current Plan</span>
                                                                                    : "" }
                                                                                    { parseInt(this.state.flavorcurrentstorage.slice(0, -2)) >= parseInt(instancedata.storage.slice(0, -2))
                                                                                        && parseInt(this.state.flavourCurrentRam.slice(0, -2)) >= parseInt(instancedata.ram.slice(0, -2))
                                                                                        && parseInt(this.state.flavourCurrentPrice) >= parseInt(instancedata.monthlyRate)
                                                                                        ?
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            //onChange={this.handleinputs}
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                            disabled>
                                                                                        </input> :
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                        // onChange={this.handleinputs}

                                                                                        >
                                                                                        </input>
                                                                                    }

                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </div>

                                                                        }

                                                                    </div>

                                                                    <div className="col col2" style={ { display: this.state.customPlan_options === "SCPU" ? "" : "" } }>
                                                                        <span className="strike_thru" style={ { display: this.state.isYearly && this.state.discount != 0 ? "" : "none" } }>${ getPriceForPlan(instancedata.monthlyRate, this.state.discount) }</span>
                                                                        <span className="offer_amount" style={ { display: this.state.isYearly ? "" : "none" } }>${ getPriceForOfferPlan(instancedata.monthlyRate, this.state.discount) }</span>
                                                                        <span className="strike_thru" style={ { display: this.state.isPrepaidMonthly && this.state.discount != 0 ? "" : "none" } }>${ instancedata.monthlyRate }</span>
                                                                        <span className="offer_amount" style={ { display: this.state.isPrepaidMonthly ? "" : "none" } }>${ getPriceForOfferMonthlyPlan(instancedata.monthlyRate, this.state.discount) }</span>
                                                                        <span style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? "none" : "" } }> ${ instancedata.monthlyRate }</span>

                                                                    </div>
                                                                    <div className="col col3" style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? "none" : "" } }>${ instancedata.hourlyRate }</div>

                                                                    <div className="col col4">{ instancedata.ram }</div>
                                                                    <div className="col col5">{ instancedata.processor }</div>
                                                                    <div className="col col6">{ instancedata.storage }</div>
                                                                </li>

                                                            ) }
                                                        </ul> :
                                                        <ul>

                                                            { this.state.instanceFilterPlans.map((instancedata, i) =>

                                                                <li key={ i }
                                                                    className={
                                                                        this.state.flavorcurrentplan !== instancedata.id && parseInt(this.state.flavorcurrentstorage.slice(0, -2)) <= parseInt(instancedata.storage.slice(0, -2)) && parseInt(this.state.flavourCurrentRam.slice(0, -2)) <= parseInt(instancedata.ram.slice(0, -2)) && parseInt(this.state.flavourCurrentCpu) <= parseInt(instancedata.processor.slice(0, -4))
                                                                            && parseInt(instancedata.monthlyRate) > parseInt(this.state.flavourCurrentPrice)
                                                                            /* this.state.flavorcurrentplan === instancedata.id || parseInt(this.state.flavorcurrentstorage.slice(0,-2))>=parseInt(instancedata.storage.slice(0,-2))
                                                                             || parseInt(this.state.flavourCurrentRam.slice(0,-2))>=parseInt(instancedata.ram.slice(0,-2))
                                                                             || parseInt(this.state.flavourCurrentCpu)>=parseInt(instancedata.processor.slice(0,-4))*/
                                                                            ? "tr "
                                                                            : "tr current_plan" }


                                                                    onClick={ (event) => this.setRadioButtonValue(event, instancedata.id, "", instancedata.storage, instancedata.ram, instancedata.processor, instancedata.monthlyRate) }>
                                                                    <div className="col col1">
                                                                        { this.state.customPlan_options === "SCPU" ?
                                                                            <div className="customPlans_radio_wrap">

                                                                                <label className={ instancedata.id === this.state.getselectedplan ? "custom_radio active" : "custom_radio" }>{ instancedata.planName } { this.state.flavorcurrentplan === instancedata.id
                                                                                    ? <span className="curr_plan_tag">Current Plan</span>
                                                                                    : "" }
                                                                                    { parseInt(this.state.flavorcurrentstorage.slice(0, -2)) > parseInt(instancedata.storage.slice(0, -2))
                                                                                        ?
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            //onChange={this.handleinputs}
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                            disabled>
                                                                                        </input> :
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                        // onChange={this.handleinputs}

                                                                                        >
                                                                                        </input>
                                                                                    }

                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </div>
                                                                            :
                                                                            <div className="customPlans_radio_wrap">

                                                                                <label className={ instancedata.id === this.state.getselectedplan ? "custom_radio active" : "custom_radio" }>{ instancedata.planName } { this.state.flavorcurrentplan === instancedata.id
                                                                                    ? <span className="curr_plan_tag">Current Plan</span>
                                                                                    : "" }
                                                                                    { this.state.flavorcurrentplan !== instancedata.id && parseInt(this.state.flavorcurrentstorage.slice(0, -2)) <= parseInt(instancedata.storage.slice(0, -2)) && parseInt(this.state.flavourCurrentRam.slice(0, -2)) <= parseInt(instancedata.ram.slice(0, -2)) && parseInt(this.state.flavourCurrentCpu) <= parseInt(instancedata.processor.slice(0, -4))
                                                                                        ?
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            //onChange={this.handleinputs}
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                        >
                                                                                        </input> :
                                                                                        <input
                                                                                            type="radio"
                                                                                            name="customPlan_table_options"
                                                                                            value={ instancedata.id }
                                                                                            checked={ this.state.customPlan_table_options === instancedata.id }
                                                                                            // onChange={this.handleinputs}
                                                                                            disabled
                                                                                        >
                                                                                        </input>
                                                                                    }

                                                                                    <span className="checkmark"></span>
                                                                                </label>
                                                                            </div>

                                                                        }

                                                                    </div>

                                                                    <div className="col col2" style={ { display: this.state.customPlan_options === "SCPU" ? "" : "" } }>
                                                                        <span className="strike_thru" style={ { display: this.state.isYearly && this.state.discount != 0 ? "" : "none" } }>${ getPriceForPlan(instancedata.monthlyRate, this.state.discount) }</span>
                                                                        <span className="offer_amount" style={ { display: this.state.isYearly ? "" : "none" } }>${ getPriceForOfferPlan(instancedata.monthlyRate, this.state.discount) }</span>
                                                                        <span className="strike_thru" style={ { display: this.state.isPrepaidMonthly && this.state.discount != 0 ? "" : "none" } }>${ instancedata.monthlyRate }</span>
                                                                        <span className="offer_amount" style={ { display: this.state.isPrepaidMonthly ? "" : "none" } }>${ getPriceForOfferMonthlyPlan(instancedata.monthlyRate, this.state.discount) }</span>
                                                                        <span style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? "none" : "" } }> ${ instancedata.monthlyRate }</span>

                                                                    </div>
                                                                    <div className="col col3" style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? "none" : "" } }>${ instancedata.hourlyRate }</div>

                                                                    <div className="col col4">{ instancedata.ram }</div>
                                                                    <div className="col col5">{ instancedata.processor }</div>
                                                                    <div className="col col6">{ instancedata.storage }</div>
                                                                </li>

                                                            ) }
                                                        </ul> }
                                                </div>
                                            </div>
                                            <p className="offer_note" style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? "" : "none" } }>
                                                <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                                <span style={ { display: this.state.discount != 0 && this.state.isYearly ? "" : "none" } }><br></br>- The { this.state.discount }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.</span>
                                                <span style={ { display: this.state.discount != 0 && this.state.isPrepaidMonthly ? "" : "none" } }><br></br>- The { this.state.discount }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.</span>
                                                <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="note_sec" style={ { display: "none" } }>Note: You must
                            <a><span onClick={ this.shutOff }> turn off </span></a>
                            an instance to resize it.</div>
                        { this.state.customPlan_options === "SCPU" ?
                            <span className="comm_error_msg" id="spanOutage" style={ { display: this.state.resizeOutage ? "" : "none" } }> Resize for shared instance can not be performed due to resource outage in this region. <a href="https://www.idrivecompute.com/support.htm" target="_blank">Contact Support.</a> </span>
                            :
                            <span className="comm_error_msg" id="spanOutage" style={ { display: this.state.resizeOutage ? "" : "none" } }> Resize for dedicated instance can not be performed due to resource outage in this region. <a href="https://www.idrivecompute.com/support.htm" target="_blank">Contact Support.</a> </span>
                        }

                        { this.state.customPlan_options === "SCPU" ?
                            <input
                                type="button"
                                value="Resize"
                                className={ this.state.flavorcurrentplan !== this.state.customPlan_table_options && parseInt(this.state.flavourSelectedPrice) > parseInt(this.state.flavourCurrentPrice) && parseInt(this.state.flavorcurrentstorage.slice(0, -2)) <= parseInt(this.state.flavourSelectedStorage.slice(0, -2)) && this.props.isTaskStateNull ? "common_cta_btn blue resize_cta" : "common_cta_btn blue resize_cta disabled" }
                                onClick={ (event) => this.resizeBtnClick(event) } disabled={ this.state.flavorcurrentplan !== this.state.customPlan_table_options && parseInt(this.state.flavourSelectedPrice) > parseInt(this.state.flavourCurrentPrice) && parseInt(this.state.flavorcurrentstorage.slice(0, -2)) <= parseInt(this.state.flavourSelectedStorage.slice(0, -2)) && this.props.isTaskStateNull ? false : true }></input>
                            :
                            <input
                                type="button"
                                value="Resize"
                                className={ this.state.flavorcurrentplan !== this.state.customPlan_table_options && parseInt(this.state.flavourSelectedPrice) > parseInt(this.state.flavourCurrentPrice) && parseInt(this.state.flavorcurrentstorage.slice(0, -2)) <= parseInt(this.state.flavourSelectedStorage.slice(0, -2)) && parseInt(this.state.flavourCurrentRam.slice(0, -2)) <= parseInt(this.state.flavourSelectedRam.slice(0, -2)) && parseInt(this.state.flavourCurrentCpu) <= parseInt(this.state.flavourSelectedCpu.slice(0, -4)) && this.props.isTaskStateNull ? "common_cta_btn blue resize_cta" : "common_cta_btn blue resize_cta disabled" }
                                onClick={ (event) => this.resizeBtnClick(event) } disabled={ this.state.flavorcurrentplan !== this.state.customPlan_table_options && parseInt(this.state.flavourSelectedPrice) > parseInt(this.state.flavourCurrentPrice) && parseInt(this.state.flavorcurrentstorage.slice(0, -2)) <= parseInt(this.state.flavourSelectedStorage.slice(0, -2)) && parseInt(this.state.flavourCurrentRam.slice(0, -2)) <= parseInt(this.state.flavourSelectedRam.slice(0, -2)) && parseInt(this.state.flavourCurrentCpu) <= parseInt(this.state.flavourSelectedCpu.slice(0, -4)) && this.props.isTaskStateNull ? false : true }></input>
                        }

                    </div>
                </div> }
                <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) }
                    msgType={ this.state.msgType } />
                <div className="main_popup delete_instanceSetting_popup" id="resizeInst">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ this.resizeClose }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Resize</div>
                                </div>
                                <div className="resize_popup_body">
                                    { this.state.isYearly ?

                                        <div className="popup_body">
                                            <p>You are subscribing to a prepaid yearly plan and your credit card will be charged <b>${ this.state.amountChargeToResize }</b> for the chosen plan. This amount is non-refundable.</p>
                                            <p className="usage-amt">Amount Payable: <span>${ this.state.amountChargeToResize }</span></p>
                                            <p className="imp_warn_note"><strong>Warning:</strong> The resize operation is irreversible. The instance will be powered off first and then the resize will happen.</p>
                                            <p>Are you sure you want to resize the instance <b>{ this.props.instance.name }</b> ?</p>
                                        </div>
                                        :
                                        this.state.isPrepaidMonthly ?
                                            <div className="popup_body">
                                                <p>You are subscribing to a prepaid monthly plan and your credit card will be charged <b>${ this.state.amountChargeToResize }</b> for the chosen plan. This amount is non-refundable.</p>
                                                <p className="usage-amt">Amount Payable: <span>${ this.state.amountChargeToResize }</span></p>
                                                <p className="imp_warn_note"><strong>Warning:</strong> The resize operation is irreversible. The instance will be powered off first and then the resize will happen.</p>
                                                <p>Are you sure you want to resize the instance <b>{ this.props.instance.name }</b> ?</p>
                                            </div>
                                            :
                                            <div className="popup_body">
                                                <p className="imp_warn_note"><strong>Warning:</strong> The resize operation is irreversible. The instance will be powered off first and then the resize will happen.</p>
                                                <p>Are you sure you want to resize the instance <b>{ this.props.instance.name }</b> ?</p>
                                            </div>
                                    }
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button type="button" className="btn btn_confirm" onClick={ (event) => this.submit(event) } id="setresizeBtn" >Resize</button>
                                        <button type="button" className="btn btn_cancel" onClick={ (event) => this.resizeClose(event) } >Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Resize;


function getPriceForOfferPlan(price, discount) {
    price = parseInt(price * 12);
    discount = parseInt(discount);
    let final = price - (price * (discount / 100));
    return Math.round((final + Number.EPSILON) * 100) / 100;
}
function getPriceForOfferMonthlyPlan(price, discount) {
    discount = parseInt(discount);
    let final = price - (price * (discount / 100));
    return Math.round((final + Number.EPSILON) * 100) / 100;
}
function getPriceForPlan(price, discount) {
    return parseInt(price * 12);
}